/* ============
 * Getters for the global module
 * ============
 *
 * The getters that are available on the
 * global module.
 */
export const recshares = (state) => {
  return state.recshares
}
export const total = (state) => {
  return state.total
}
export const offset = (state) => {
  return state.offset
}
export const max = (state) => {
  return state.max
}
export const getRecshareById = (state) => (id) => {
  return state.recshares.find(item => item.id === id)
}
export const sort = (state) => {
  return state.sort
}
export const order = (state) => {
  return state.order
}
export default {
  recshares,
  total,
  offset,
  max,
  getRecshareById,
  sort,
  order
}
